// Anonyme Funktion zur Steuerung der Inhaltsumschalter
(function () {
  /* Toggle content */
  $('.product-description-more').click(function (e) {
    e.preventDefault();
    $(this).closest('.product-description-short').next().show();
    $(this).closest('.product-description-short').hide();
  });

  $('.product-description-less').click(function (e) {
    e.preventDefault();
    $(this).closest('.product-description-full').prev().show();
    $(this).closest('.product-description-full').hide();
  });

  /* Toggle fields */
  $('.js-show-more').click(function (e) {
    e.preventDefault();
    $(this).siblings('input').removeClass('hidden');
    $(this).siblings('label').removeClass('hidden');
    $(this).remove();
  });
})();

/* Definition der FloatedForm Klasse */
class FloatedForm extends HTMLElement {
  constructor() {
    super();
    this.renderForm();
  }

  renderForm() {
    fetch(this.getAttribute('data-product-url'))
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]');

        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(this, this.productElement.innerHTML);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.showMoreFields();
        const event = new CustomEvent("floatedFormLoaded");
        document.dispatchEvent(event);
      })
      .catch((error) => {
        console.error('Fehler beim Laden des Formulars:', error);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution.
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
      sectionId,
      `floated-${sectionId}`
    );

    this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((element) => {
      element.dataset.originalSection = sectionId;
    });
  }

  removeDOMElements() {
    const selectorsToRemove = [
      '.product__text',
      '.share-buttons',
      '.rating',
      '.product-tags',
      '.product__description',
      '.note',
      '.promo-banner',
      '.customer',
      '.custom-liquid',
      'pickup-availability',
      'product-modal',
      'floated-form',
      'related-product',
    ];

    selectorsToRemove.forEach((selector) => {
      const elements = this.productElement.querySelectorAll(selector);
      elements.forEach((element) => element.remove());
    });

    const advantages = this.productElement.querySelectorAll('.advantage');
    advantages.forEach((advantage) => advantage.remove());
  }

  showMoreFields() {
    $('.js-show-more').click(function (e) {
      e.preventDefault();
      $(this).siblings('input').removeClass('hidden');
      $(this).siblings('label').removeClass('hidden');
      $(this).remove();
    });
  }
}

customElements.define('floated-form', FloatedForm);

// JavaScript für den "Anfrage senden"-Button
document.addEventListener('DOMContentLoaded', function () {
  var anfrageButton = document.getElementById('anfrage-button');
  var anfragePopup = document.getElementById('anfrage-popup');
  var closePopup = document.getElementById('close-popup');

  if (anfrageButton) {
    anfrageButton.addEventListener('click', function () {
      anfragePopup.style.display = 'block';
    });
  }

  if (closePopup) {
    closePopup.addEventListener('click', function () {
      anfragePopup.style.display = 'none';
    });
  }

  window.addEventListener('click', function (event) {
    if (event.target == anfragePopup) {
      anfragePopup.style.display = 'none';
    }
  });
});
